export async function fetchAudio(url, asBlob = false) {
    if (!url) {
        throw new Error('TextToSpeech URL cannot be empty');
    }

    if (Array.isArray(url)) {
        if (url.length > 1) {
            return await fetchMergedAudio(url)
        }
        if (url.length === 1) {
            url = url[0]
        }
    }

    try {
        const response = await fetch(url);

        if (!response.ok) {
            window.sentry.withScope(scope => {
                scope.setExtra('response', response);
                window.sentry.captureMessage('Synthesize returned non-ok response', 'error');
            });
            throw new Error('Something went wrong while trying to download audio');
        }

        if (response.headers.get('content-type')?.includes('application/json')) {
            const json = await response.json();

            if (json.status === 'error') {
                window.sentry.withScope(scope => {
                    scope.setExtra('json', json);
                    window.sentry.captureMessage(json.message, 'error');
                });
            }

            if (json.error_code === 35202) {
                json.displayMessage = window.i18n.gettext('Audio is not ready yet. Please wait.')
            }

            throw json;
        }

        const arrayBuffer = await response.arrayBuffer();
        return asBlob ? new Blob([arrayBuffer], { type: 'audio/mp3' }) : arrayBuffer;
    } catch (error) {
        if (error.displayMessage) {
            throw error;
        }

        // probably network error
        error.status = 'error';
        error.displayMessage = window.i18n.gettext('Something went wrong while trying to download audio');
        throw error;
    }
}

export async function fetchMergedAudio(urls, maxAttempts = 16) {
    const audioBlobs = await Promise.all(urls.map((url) => {
        return attemptFetchAudio(url, 0, maxAttempts)
    }))
    return new Blob(audioBlobs, {type: 'audio/mp3'})
}

async function attemptFetchAudio(url, attempt = 0, maxAttempts = 16) {
    attempt++
    try {
        return await fetchAudio(url, true)
    } catch (error) {
        // If audio is not ready yet, wait 0.4 seconds and try again. Otherwise throw an error.
        if (error.error_code === 35202 && attempt <= maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, 400))
            return attemptFetchAudio(url, attempt, maxAttempts)
        }
        throw error
    }
}
